import React from "react";
import Paso5 from "../../components/CotizacionHogar/CotizacionResumenPaso5";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";


class ContainerCotizacionPaso5 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {    
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">                    
          <Paso5/>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({  
});

const mapDispatchToProps = dispatch => {
  return {
    
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionPaso5)
);
